module.exports = new __parcel__URL__("shop_machines_mainframe_v2.2afa78d0.png").toString();